import React from "react";
import { useState, useEffect } from "react";
import axiosInstance from "../../../helpers/axios";
import { Box, Typography, CircularProgress, Button } from "@mui/material";
import {
  Phone as PhoneIcon,
  Message as MessageIcon,
  Email as EmailIcon,
  WhatsApp as WhatsAppIcon,
  CloudDownload as CloudDownloadIcon,
} from "@mui/icons-material";
import NotificationMediumReport from "../../NotificationReport/NotificationHistoryReport/NotificationMediumReport";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useCurrentUser } from '../../../hooks/useCurrentUser';

const NotificationReport = ({ profileDetails, userId, applicationId }) => {
  // alert(JSON.stringify(profileDetails));
  // alert(JSON.stringify(userId));
  // alert(JSON.stringify(applicationId));
  const decode = useCurrentUser();
  const user = null;

  // notification hiistory begin
  const [notificationCategory, setNotificationCategory]= useState("preDisbursement")
  const [smsData, setSmsData] = useState([]);
  const [ivrData, setIvrData] = useState([]);
  const [whatsappData, setWhatsappData] = useState([]);
  const [emailData, setEmailData] = useState([]);
  const [emailPagination, setEmailPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRows: 0,
    rowsPerPage: 5,
  });

  const [smsPagination, setSmsPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRows: 0,
    rowsPerPage: 5,
  });

  const [whatsappPagination, setWhatsappPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRows: 0,
    rowsPerPage: 5,
  });

  const [ivrPagination, setIvrPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRows: 0,
    rowsPerPage: 5,
  });

  const [loadingStates, setLoadingStates] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
  });

  const smsFields = [
    // { key: "legacy_loan_id", label: "Loan ID" },
    { key: "application_id", label: "Application ID" },
    { key: "phone_number", label: "Mobile" },
    { key: "type", label: "Message Type" },
    { key: "sent_at", label: "Sent Date", type: "date" },
    // { key: 'sent', label: 'Status', type: 'status' }
    { key: "sent", label: "sent" },
  ];

  const ivrFields = [
    { key: "legacy_loan_id", label: "Legacy Loan Id" },
    { key: "loan_id", label: "Loan Id" },
    { key: "application_id", label: "Application ID" },
    { key: "type", label: "type" },
    { key: "phone_number", label: "Mobile" },
    { key: "generated_at", label: "Generated At" },
    { key: "sent_at", label: "Sent Date", type: "date" },

    { key: "call_order_id", label: "Call Order ID" },
    { key: "call_time", label: "Call Time", type: "date" },
    { key: "call_duration", label: "Call Duration" },
    { key: "call_id", label: "Call ID" },

    // { key: 'sent', label: 'Status', type: 'status' }
  ];

  const whatsappFields = [
    // { key: "legacy_loan_id", label: "Legacy Loan Id" },
    // { key: "loan_id", label: "Loan Id" },
    { key: "application_id", label: "Application ID" },
    { key: "type", label: "type" },
    // { key: "phone_number", label: "Mobile" },
    // { key: "generated_at", label: "Generated At" },
    // { key: 'whatsapp_id', label: 'WhatsApp ID' },
    { key: "sent_at", label: "Sent Date", type: "date" },
    // { key: 'sent', label: 'Status', type: 'status' },
    { key: "sent", label: "sent" },
    { key: "delivered", label: "Delivered" },
    { key: "read", label: "Read" },
  ];

  const emailFields = [
    { key: "legacy_loan_id", label: "Loan ID" },
    { key: "application_id", label: "Application ID" },
    // { key: 'email', label: 'Email' },
    // { key: 'subject', label: 'Subject' },
    { key: "sent_at", label: "Sent Date", type: "date" },
    { key: "sent", label: "Status", type: "status" },
    { key: "type", label: "type" },
    { key: "phone_number", label: "Mobile" }
  ];

  const cards = {
    // WhatsApp: { label: "WhatsApp", mediumCode: 3 },
    WhatsApp: { label: "WhatsApp", mediumCode: 5 },
    SMS: { label: "SMS", mediumCode: 2 },
    OBD: { label: "OBD", mediumCode: 4 },
    Email: { label: "Email", mediumCode: 1 },
  };








  const getPaginationConfig = (mediumCode) => {
    switch (mediumCode) {
      case cards.Email.mediumCode:
        return [emailPagination, setEmailPagination];
      case cards.SMS.mediumCode:
        return [smsPagination, setSmsPagination];
      case cards.WhatsApp.mediumCode:
        return [whatsappPagination, setWhatsappPagination];
      case cards.OBD.mediumCode:
        return [ivrPagination, setIvrPagination];
      default:
        return [null, null];
    }
  };

  const setDataByMedium = (mediumCode, data) => {
    if (mediumCode === cards.Email.mediumCode) setEmailData(data);
    if (mediumCode === cards.SMS.mediumCode) setSmsData(data);
    if (mediumCode === cards.WhatsApp.mediumCode) setWhatsappData(data);
    if (mediumCode === cards.OBD.mediumCode) setIvrData(data);
  };

 

  async function fetchDataBasedOnMedium(
    mediumCode,
    page = null,
    rowsPerPage = null
  ) {
    const [pagination, setPagination] = getPaginationConfig(mediumCode);
    if (!pagination) return;

    const currentPage = page ?? pagination.currentPage;
    const perPage = rowsPerPage ?? pagination.rowsPerPage;

    // const queryParams = {
    //   medium: mediumCode,
    //   perPage,
    //   pageNo: currentPage
    //   // Add searchQuery, sentstartDate, sentendDate if required
    //  NEW: Set loading state and clear data immediately when starting fetch
    setLoadingStates((prev) => ({ ...prev, [mediumCode]: true }));

    // NEW: Clear current data to show loading state immediately
    setDataByMedium(mediumCode, []);
    // };
    const queryParams = {};

    // if (searchQuery.startsWith("MCL")) {
    //   queryParams.loanId = searchQuery;
    // } else if (searchQuery.startsWith("GBP")) {
    //   queryParams.legacyLoanId = searchQuery;
    // } else if (searchQuery.startsWith("FM")) {
    //   queryParams.applicationId = searchQuery;
    // } else if (searchQuery) {
    //   queryParams.mobile = searchQuery;
    // }

    if (mediumCode) {
      queryParams.medium = mediumCode;
    }

    // if (sentstartDate && sentendDate) {
    //   const formattedStartDate = moment(sentstartDate, "DD MMM YYYY").format(
    //     "YYYY-MM-DD"
    //   );
    //   const formattedEndDate = moment(sentendDate, "DD MMM YYYY").format(
    //     "YYYY-MM-DD"
    //   );

    //   queryParams.startDate = formattedStartDate;
    //   queryParams.endDate = formattedEndDate;
    // } else {
    //   const startDateFrom = moment().startOf("month");
    //   const endDateTo = moment();
    //   const formattedStartDate = endDateTo.format("YYYY-MM-DD");
    //   const formattedEndDate = endDateTo.format("YYYY-MM-DD");
    //   if (formattedStartDate && formattedEndDate) {
    //     queryParams.startDate = formattedStartDate;
    //     queryParams.endDate = formattedEndDate;
    //   }
    // }
    if (mediumCode === 1) {
        queryParams.email = profileDetails?.email;
      } 


    queryParams.mobile = mediumCode === cards.WhatsApp.mediumCode ? profileDetails?.whatsappNumber : profileDetails?.mobile;
    // queryParams.notificationType = 'preDisbursement'
    //  queryParams.notificationType = 'overallNotifications'
    queryParams.notificationType = notificationCategory
    queryParams.applicationId = applicationId

    if (perPage && currentPage) {
      queryParams.perPage = perPage;
      queryParams.pageNo = currentPage;
    }

    setLoadingStates((prev) => ({ ...prev, [mediumCode]: true }));

    try {
      const response = await axiosInstance.get(
        "/notification/get-History-Notifications",
        {
          params: queryParams,
          headers: {
          },
        }
      );

      const data = response?.data?.data?.data || [];
      const totalRows = response?.data?.data?.totalRows || data.length;
      const totalPages = Math.ceil(totalRows / perPage);

      setDataByMedium(mediumCode, data);
      setPagination((prev) => ({
        ...prev,
        currentPage,
        rowsPerPage: perPage,
        totalRows,
        totalPages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
      setDataByMedium(mediumCode, []);
      alert(error?.response?.data?.message || "Failed to fetch data");
    } finally {
      setLoadingStates((prev) => ({ ...prev, [mediumCode]: false }));
    }
  }

//   excel download begin

 const [downloadLoading, setDownloadLoading] = useState({
    overall: false,
    1: false, // Email
    2: false, // SMS
    3: false, // WhatsApp
    4: false, // IVR
  });

  // Download functions
 const downloadIndividualReport = async (mediumCode) => {

  const selectedContact =
  mediumCode === cards.WhatsApp.mediumCode
    ? profileDetails?.whatsappNumber
    : profileDetails?.mobile;

  if (!selectedContact || selectedContact.trim() === '') {
    alert("Mobile number doesn't exist. Cannot download report.");
    return;
  }

  
    setDownloadLoading((prev) => ({ ...prev, [mediumCode]: true }));

    try {
      const currentDate = new Date();
      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const year = String(currentDate.getFullYear());
      const formattedDate = `${day}-${month}-${year}`;

      const queryParams = {
        medium: mediumCode,
        mobile: mediumCode === cards.WhatsApp.mediumCode ? profileDetails?.whatsappNumber: profileDetails?.mobile,
        // Add other filters as needed
        // startDate: startDate,
        // endDate: endDate,
        // notificationType: 'overallNotifications'
        notificationType : notificationCategory,
        applicationId : applicationId
      };

       if (mediumCode === 1) {
        queryParams.email = profileDetails?.email;
      } 


      const response = await axiosInstance.get("/notification/download-notification-history", {
        params: queryParams,
        responseType: 'arraybuffer',
        headers: {
        }
      });

      // Get medium name for filename
      const mediumNames = {
        1: 'Email',
        2: 'SMS',
        3: 'WhatsApp',
        4: 'IVR'
      };
      
      const mediumName = mediumNames[mediumCode] || 'Notification';
      
      const blob = new Blob([response.data], { type: "application/xlsx" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${mediumName}_Notifications_${formattedDate}.xlsx`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the URL object
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error("Error downloading report:", error);
      // alert("Error Downloading Individual Report");
        alert("Error downloading individual report. Please try again.");
    } finally {
      setDownloadLoading((prev) => ({ ...prev, [mediumCode]: false }));
    }
  };

  // Download functions - Overall download
  const downloadOverallReport = async () => {

      if (!profileDetails?.mobile || profileDetails.mobile.trim() === '') {
        alert("Mobile number doesn't exist. Cannot download overall report.");
        return;
      }

    setDownloadLoading((prev) => ({ ...prev, overall: true }));

    try {
      const currentDate = new Date();
      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const year = String(currentDate.getFullYear());
      const formattedDate = `${day}-${month}-${year}`;

      const queryParams = {
        mobile: profileDetails?.mobile,
        // Add other common filters
        // startDate: startDate,
        // endDate: endDate,
        // notificationType: 'overallNotifications'
        notificationType : notificationCategory,
         applicationId : applicationId,
         email : profileDetails?.email
      };

      //  if (mediumCode === 1) {
      //   queryParams.email = profileDetails?.email;
      // } 


      const response = await axiosInstance.get("/notification/download-all-notifications", {
        params: queryParams,
        responseType: 'arraybuffer',
        headers: {
        }
      });

      const blob = new Blob([response.data], { type: "application/xlsx" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `All_Notifications_Report_${formattedDate}.xlsx`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the URL object
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error("Error downloading overall report:", error);
      // alert("Error Downloading Overall Report");
      alert("Error downloading overall report. Please try again.");
    } finally {
      setDownloadLoading((prev) => ({ ...prev, overall: false }));
    }
  };

// end

  const handlePageChange = (mediumCode, page) => {
    const [pagination] = getPaginationConfig(mediumCode);
    if (!pagination) return;
    const [, setPagination] = getPaginationConfig(mediumCode);
    setPagination((prev) => ({
      ...prev,
      currentPage: page,
    }));
    fetchDataBasedOnMedium(mediumCode, page, pagination.rowsPerPage);
  };

  const handleRowsPerPageChange = (mediumCode, newRowsPerPage) => {
    const [pagination, setPagination] = getPaginationConfig(mediumCode);
    setPagination((prev) => ({
      ...prev,
      rowsPerPage: newRowsPerPage,
      currentPage: 1, // Reset to first page when changing rows per page
    }));
    fetchDataBasedOnMedium(mediumCode, 1, newRowsPerPage);
  };

  const handleRefresh = (mediumCode) => {
    fetchDataBasedOnMedium(mediumCode);
  };

  // const handleExport = (mediumCode) => {
  //   alert(`Exporting data for medium code: ${mediumCode}`);

  //   if (profileDetails?.mobile) {
  //     downloadIndividualReport(mediumCode);
  //   } else {
  //     alert("mobile Number doesn't exists")
  //   }
    
  // };

  const handleExport = (mediumCode) => {
  // Check if mobile number exists and is valid
  const selectedMobile =
    mediumCode === cards.WhatsApp.mediumCode
      ? profileDetails?.whatsappNumber
      : profileDetails?.mobile;

  if (!selectedMobile || selectedMobile.trim() === '') {
    alert("Mobile number doesn't exist. Cannot export report.");
    return;
  }
  downloadIndividualReport(mediumCode);
};

  // end

  const [showHistoryView, setShowHistoryView] = useState(true);
  const [expandedAccordions, setExpandedAccordions] = useState({
    [cards.WhatsApp.mediumCode]: true,
  });
  useEffect(() => {
    fetchDataBasedOnMedium(cards.WhatsApp.mediumCode);
  }, []);

  const handleAccordionChange = (mediumCode) => async (event, isExpanded) => {
    setExpandedAccordions(prev => ({ ...prev, [mediumCode]: isExpanded }));
    if (isExpanded) {
      await fetchDataBasedOnMedium(mediumCode);
    }
  };
  return (
    <div className="notification-report-container">
      {/* <h2>Notification Report</h2> */}
      {showHistoryView ? (
        <Box sx={{ p: 2, backgroundColor: "#f5f5f5", borderRadius: 2 }}>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4, fontWeight: 600 }}>
            Notification Reports
          </Typography>
          {/* excel download begin */}
          <Button
                        variant="contained"
                        startIcon={downloadLoading.overall ? <CircularProgress size={16} color="inherit" /> : <CloudDownloadIcon />}
                        onClick={downloadOverallReport}
                        disabled={downloadLoading.overall}
                        sx={{
              background: 'linear-gradient(90deg, #43cea2, #185a9d)', // teal → blue gradient
              '&:hover': {
                background: 'linear-gradient(90deg, #3cbfa0, #144f87)', // slightly lighter hover
                boxShadow: 4,
              },
              '&:active': {
                background: 'linear-gradient(90deg, #36b293, #104677)', // pressed state
              },
              borderRadius: 3,
              px: 3.5,
              py: 1.5,
              fontSize: '1rem',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: 2,
              transition: 'all 0.3s ease',
              minWidth: 220,
              color: '#fff',
            }}
            >
              {downloadLoading.overall ? 'Downloading...' : 'Download All Reports'}
            </Button>
          {/* excel download end */}
          </Box>
          {/* WhatsApp Report */}
          <Accordion
            expanded={expandedAccordions[cards.WhatsApp.mediumCode] || false}
            onChange={handleAccordionChange(cards.WhatsApp.mediumCode)}
            sx={{ mb: 2 }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <WhatsAppIcon sx={{ color: '#25d366', mr: 1 }} />
              <Typography fontWeight={600}>WhatsApp Notifications</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
          <NotificationMediumReport
            medium={cards.WhatsApp.mediumCode}
            mediumName="WhatsApp"
            data={whatsappData}
            loading={loadingStates[cards.WhatsApp.mediumCode]}
            fields={whatsappFields}
            pagination={whatsappPagination}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onRefresh={handleRefresh}
            onExport={handleExport}
            mediumColor="#25d366"
            icon={WhatsAppIcon}
          />
            </AccordionDetails>
          </Accordion>
          {/* IVR Report */}
          <Accordion
            expanded={expandedAccordions[cards.OBD.mediumCode] || false}
            onChange={handleAccordionChange(cards.OBD.mediumCode)}
            sx={{ mb: 2 }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PhoneIcon sx={{ color: '#9c27b0', mr: 1 }} />
              <Typography fontWeight={600}>IVR Notifications</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
          <NotificationMediumReport
            medium={cards.OBD.mediumCode}
            mediumName="IVR"
            data={ivrData}
            loading={loadingStates[cards.OBD.mediumCode]}
            fields={ivrFields}
            pagination={ivrPagination}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onRefresh={handleRefresh}
            onExport={handleExport}
            mediumColor="#9c27b0"
            icon={PhoneIcon}
          />
            </AccordionDetails>
          </Accordion>
          {/* SMS Report */}
          <Accordion
            expanded={expandedAccordions[cards.SMS.mediumCode] || false}
            onChange={handleAccordionChange(cards.SMS.mediumCode)}
            sx={{ mb: 2 }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <MessageIcon sx={{ color: '#1976d2', mr: 1 }} />
              <Typography fontWeight={600}>SMS Notifications</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
          <NotificationMediumReport
            medium={cards.SMS.mediumCode}
            mediumName="SMS"
            data={smsData}
            loading={loadingStates[cards.SMS.mediumCode]}
            fields={smsFields}
            pagination={smsPagination}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onRefresh={handleRefresh}
            onExport={handleExport}
            mediumColor="#1976d2"
            icon={MessageIcon}
          />
            </AccordionDetails>
          </Accordion>
          {/* Email Report */}
          <Accordion
            expanded={expandedAccordions[cards.Email.mediumCode] || false}
            onChange={handleAccordionChange(cards.Email.mediumCode)}
            sx={{ mb: 2 }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <EmailIcon sx={{ color: '#ff9800', mr: 1 }} />
              <Typography fontWeight={600}>Email Notifications</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
          <NotificationMediumReport
            medium={cards.Email.mediumCode}
            mediumName="Email"
            data={emailData}
            loading={loadingStates[cards.Email.mediumCode]}
            fields={emailFields}
            pagination={emailPagination}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onRefresh={handleRefresh}
            onExport={handleExport}
            mediumColor="#ff9800"
            icon={EmailIcon}
          />
            </AccordionDetails>
          </Accordion>
        </Box>
      ) : (
        <></>
      )}
    </div>
  );
};

export default NotificationReport;
